/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairflow2Inputs */



/**
* | output |
* | --- |
* | "Supply airflow" |
*
* @param {Ahu_History_Key_Supplyairflow2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairflow2 = /** @type {((inputs?: Ahu_History_Key_Supplyairflow2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairflow2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply airflow")
	return /** @type {LocalizedString} */ ("Débit air soufflé")
});
export { ahu_history_key_supplyairflow2 as "ahu_history_key_supplyAirFlow" }